import React from "react";
import MenuItem from "@mui/material/MenuItem";
import CheckIcon from "@mui/icons-material/Check";

export const CheckMenuItem = React.forwardRef(({ children, ...props }, ref) => {
  return (
    <MenuItem
      ref={ref}
      {...props}
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px 14px",
        borderRadius: "10px",
        color: props.selected ? "#3b82f6" : "#374151",
        backgroundColor: props.selected ? "transparent !important" : "inherit",
        "&:hover": {
          backgroundColor: props.selected ? "rgba(59, 130, 246, 0.04)" : "#f3f4f6",
        },
        "&.Mui-selected": {
          color: "#4f46e5",
          fontWeight: "400 !important", // Keeps typography thin and elegant when active
        },

        ...props.sx,
      }}
    >
      {children}
      {props.selected && (
        <CheckIcon
          sx={{
            width: "20px !important",
            height: "20px !important",
            color: "#3246d3",
          }}
        />
      )}
    </MenuItem>
  );
});
